/**
 * @license
 * Copyright Akveo. All Rights Reserved.
 * Licensed under the MIT License. See License.txt in the project root for license information.
 */
// The file contents for the current environment will overwrite these during build.
// The build system defaults to the dev environment which uses `environment.ts`, but if you do
// `ng build --env=prod` then `environment.prod.ts` will be used instead.
// The list of which env maps to which file can be found in `.angular-cli.json`.

export const environment = {
  firebase: {
    apiKey: "AIzaSyCmH7XLYTIlm9bGBMpt1ulS5pgfyaHhph8",
    authDomain: "digi-doc-3104c.firebaseapp.com",
    projectId: "digi-doc-3104c",
    storageBucket: "digi-doc-3104c.appspot.com",
    messagingSenderId: "71639148329",
    appId: "1:71639148329:web:c1429f588a66740b1eb938",
    measurementId: "G-WQ38N03PX0"
  },
  production: false,
};
